export default "mutation {\n  initShippingStep {\n    order {\n      isRegistrationValid\n      isShippingValid\n      isPaymentValid\n    }\n  }\n}\n"